import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

function remaining(ts) {
  const diff = Math.max(0, ts - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
    over: diff === 0,
  };
}

// Compte à rebours de commande (offres à date butoir). variant="dark" sur fond sombre (bandeau), sinon ivoire.
export default function OrderCountdown({ deadline, label, variant = "light" }) {
  const [left, setLeft] = useState(() => remaining(deadline.ts));
  useEffect(() => {
    const t = setInterval(() => setLeft(remaining(deadline.ts)), 1000);
    return () => clearInterval(t);
  }, [deadline.ts]);
  if (left.over) return null;
  const dark = variant === "dark";
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-[0.72rem] font-semibold tracking-wide ${
        dark ? "bg-[#FAF6F0]/10 text-[#F0E3C0] border border-[#C5A059]/50" : "bg-[#6B1226]/5 text-[#6B1226] border border-[#6B1226]/25"
      }`}
      data-testid="order-countdown"
    >
      <Timer size={13} className="shrink-0" />
      <span>{label || "Commande limitée"}</span>
      <span className={`tabular-nums font-bold ${dark ? "text-[#C5A059]" : "text-[#6B1226]"}`}>
        J-{left.days} · {pad(left.hours)}:{pad(left.mins)}:{pad(left.secs)}
      </span>
    </div>
  );
}
